import { Roles } from 'enums';
import { AppRootStateType } from 'state/reducers';
import { UserType } from 'state/reducers/auth/types';

export const selectAccessToken = (state: AppRootStateType): string =>
  state.auth.accessToken;
export const selectUser = (state: AppRootStateType): UserType => state.auth.user;
export const selectUserRole = (state: AppRootStateType): Roles => state.auth.user.role;
export const selectRecoveryToken = (state: AppRootStateType): string =>
  state.auth.recoveryToken;
export const selectNotification = (state: AppRootStateType): string =>
  state.auth.notification;
export const selectError = (state: AppRootStateType): string | null => state.auth.error;
export const selectLoading = (state: AppRootStateType): boolean => state.auth.loading;
export const selectFullLoading = (state: AppRootStateType): boolean =>
  state.auth.fullLoading;
export const selectTenant = (state: AppRootStateType): string => state.auth.tenant;
